import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=2be6b28d&scoped=true&lang=pug&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.styl?vue&type=style&index=0&id=2be6b28d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6b28d",
  null
  
)

export default component.exports